let exported = [
    'AreaChart',
    'Area',
    'BarChart',
    'PieChart',
    'Pie',
    'Cell',
    'XAxis',
    'YAxis',
    'CartesianGrid',
    'Tooltip',
    'Legend',
    'Bar',
    'Label',
    'ResponsiveContainer',
    'Sector',
    'LineChart',
    'Line',
    'ComposedChart',
    'Brush',
    'ReferenceLine',
    'ReferenceArea',
    'Rectangle',
    'ScatterChart',
    'Scatter',
    'Symbols'
];
let loader = ()=>null;
// #if process.env.UIX_CHUNKED === 'true'
loader = ()=>{
    return import(/* webpackChunkName: 'recharts' */ 'recharts');
};
// #endif
// #if process.env.UIX_CHUNKED === 'false'
// import {
//   AreaChart,
//   Area,
//   BarChart,
//   PieChart,
//   Pie,
//   Cell,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   Bar,
//   Label,
//   ResponsiveContainer,
//   Sector,
//   LineChart,
//   Line,
//   Brush,
//   ReferenceLine,
//   ReferenceArea,
//   Rectangle,
//   ScatterChart,
//   Scatter,
//   Symbols,
// } from 'recharts'
// 
// exported = {
//   AreaChart,
//   Area,
//   BarChart,
//   PieChart,
//   Pie,
//   Cell,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   Bar,
//   Label,
//   ResponsiveContainer,
//   Sector,
//   LineChart,
//   Line,
//   Brush,
//   ReferenceLine,
//   ReferenceArea,
//   Rectangle,
//   ScatterChart,
//   Scatter,
//   Symbols,
// }
// #endif
export const exportedRecharts = {
    names: exported,
    loader
};
